import DisplayProperties from "./DisplayProperties";




const Buyer = () => {
    return (
        <>
            <DisplayProperties />
        </>
    )
}

export default Buyer;